export default {
  Partner: "Partner",
  AddPartner: "AddPartner",
  editPartner: "EditPartner",
  PartnerProfile:"PartnerProfile"
};
